import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  RESET,
  RESET_GIVE_PERMISSION_STATE,
  SET_DEFAULT_VALUE,
  FETCH_EXCHANGE_RATES,
  FETCH_EXCHANGE_RATES_SUCCESS,
  FETCH_EXCHANGE_RATES_ERROR,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    givePermission: 'false',
    preferredContactNumberForClaim: '',
    preferredContactEmailForClaim: '',
    preferredContactForClaim: '',
  },
  dirty: false,
  exchangeRates: {},
  exchangeRatesLoading: false,
  exchangeRatesError: null,
});


const initialGivePermissionState = {
  form: {
    validated: true,
    givePermission: 'false',
    thirdPartyTitle: '',
    thirdPartyFirstName: '',
    thirdPartySurName: '',
    thirdPartyDateOfBirth: '',
    thirdPartyRelationShip: '',
    thirdPartyAddressLine1: '',
    thirdPartyAddressLine2: '',
    thirdPartyCity: '',
    thirdPartyCountry: '',
    thirdPartyState: '',
    thirdPartyPostal: '',
    thirdPartyMobilePhone: '',
    thirdPartyHomePhone: '',
    thirdPartyWorkPhone: '',
    thirdPartyEmail: '',
  },
};

function stepClaimSummaryReducer(state = initialState, action) {
  const properties = (action.propertyName) ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED: {
      return state.set('dirty', true)
        .setIn(properties, action.value);
    }
    case SET_DEFAULT_VALUE: {
      return state.setIn(properties, action.value);
    }
    case LOAD:
      if (action.payload) {
        return fromJS({ form: action.payload })
          .set('exchangeRates', state.get('exchangeRates'))
          .set('exchangeRatesLoading', state.get('exchangeRatesLoading'))
          .set('exchangeRatesError', state.get('exchangeRatesError'));
      }
      return initialState;
    case RESET:
      return initialState;
    case RESET_GIVE_PERMISSION_STATE:
      return state.mergeDeep(initialGivePermissionState);
    case FETCH_EXCHANGE_RATES:
      return state
        .set('exchangeRatesLoading', true)
        .set('exchangeRatesError', null);
    case FETCH_EXCHANGE_RATES_SUCCESS:
      return state
        .set('exchangeRates', fromJS(action.rates))
        .set('exchangeRatesLoading', false)
        .set('exchangeRatesError', null);
    case FETCH_EXCHANGE_RATES_ERROR:
      return state
        .set('exchangeRatesLoading', false)
        .set('exchangeRatesError', action.error);
    default:
      return state;
  }
}

export default stepClaimSummaryReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/reducer.js